import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SvgIcon from '@mui/material/SvgIcon';
import { green } from '@mui/material/colors';
function HomeIcon(props) {
    return (_jsx(SvgIcon, Object.assign({}, props, { children: _jsx("path", { d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" }) })));
}
export default function IconExample() {
    return (_jsxs("div", { children: [_jsx(HomeIcon, { sx: { m: 2 } }), _jsx(HomeIcon, { color: "primary", sx: { m: 2 } }), _jsx(HomeIcon, { color: "secondary", sx: { m: 2 } }), _jsx(HomeIcon, { color: "action", sx: { m: 2 } }), _jsx(HomeIcon, { color: "disabled", sx: { m: 2 } }), _jsx(HomeIcon, { sx: { m: 2, color: green[500] } })] }));
}
